import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

const SaveSpecDialog = ({ isOpen, onClose, onSave, getComponent, currentSpecName, isNewSpec }) => {
  const [specName, setSpecName] = useState('');
  const ConfirmDialog = getComponent('ConfirmDialog', true);

  useEffect(() => {
    if (isOpen) {
      setSpecName(currentSpecName || '');
    }
  }, [isOpen, currentSpecName]);

  const handleConfirmDialogClose = useCallback(
    (result) => {
      if (result && specName.trim()) {
        onSave(specName.trim());
      } else {
        onClose();
      }
    },
    [specName, onSave, onClose]
  );

  const handleNameChange = useCallback((event) => {
    setSpecName(event.target.value);
  }, []);

  if (!isOpen || !ConfirmDialog) return null;

  return (
    <ConfirmDialog
      isOpen={isOpen}
      title={isNewSpec ? 'Save New Spec' : 'Save Spec'}
      onClose={handleConfirmDialogClose}
    >
      <div className="input-group">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor="input-spec-name" aria-labelledby="input-spec-name">
          {isNewSpec ? 'Enter a name for the new spec' : 'Spec name'}
        </label>
        <input
          id="input-spec-name"
          type="text"
          className="form-control"
          placeholder="My API Spec"
          value={specName}
          onChange={handleNameChange}
          autoFocus
        />
      </div>
    </ConfirmDialog>
  );
};

SaveSpecDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  getComponent: PropTypes.func.isRequired,
  currentSpecName: PropTypes.string,
  isNewSpec: PropTypes.bool,
};

SaveSpecDialog.defaultProps = {
  currentSpecName: '',
  isNewSpec: true,
};

export default SaveSpecDialog;
